/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_DevicesInputs */

const th_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุปกรณ์ที่รับการแจ้งเตือน`)
};

const en_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices receiving notifications`)
};

const ja_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知を受け取る端末`)
};

const zh_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接收通知的设备`)
};

const es_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos que reciben notificaciones`)
};

const pt_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos que recebem notificações`)
};

const id_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat yang menerima notifikasi`)
};

const fr_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appareils recevant les notifications`)
};

const tl_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga device na tumatanggap ng notipikasyon`)
};

const vi_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết bị nhận thông báo`)
};

const ko_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림을 받는 기기`)
};

const de_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräte, die Benachrichtigungen erhalten`)
};

const ru_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Устройства, получающие уведомления`)
};

const tr_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim alan cihazlar`)
};

const it_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivi che ricevono le notifiche`)
};

const pl_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urządzenia otrzymujące powiadomienia`)
};

const uk_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пристрої, що отримують сповіщення`)
};

const hi_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ पाने वाले उपकरण`)
};

const ar_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأجهزة التي تتلقى الإشعارات`)
};

const ms_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranti yang menerima pemberitahuan`)
};

const bn_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যেসব যন্ত্র বিজ্ঞপ্তি পায়`)
};

const zh_tw2_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接收通知的裝置`)
};

const zh_hk2_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接收通知的裝置`)
};

const ur_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات پانے والے آلات`)
};

const fa_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دستگاه‌هایی که اعلان می‌گیرند`)
};

const sw_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vifaa vinavyopokea arifa`)
};

const nl_push_devices = /** @type {(inputs: Push_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaten die meldingen krijgen`)
};

/**
* | output |
* | --- |
* | "Devices receiving notifications" |
*
* @param {Push_DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_devices = /** @type {((inputs?: Push_DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_devices(inputs)
	if (locale === "ja") return ja_push_devices(inputs)
	if (locale === "zh") return zh_push_devices(inputs)
	if (locale === "es") return es_push_devices(inputs)
	if (locale === "pt") return pt_push_devices(inputs)
	if (locale === "id") return id_push_devices(inputs)
	if (locale === "fr") return fr_push_devices(inputs)
	if (locale === "tl") return tl_push_devices(inputs)
	if (locale === "vi") return vi_push_devices(inputs)
	if (locale === "ko") return ko_push_devices(inputs)
	if (locale === "de") return de_push_devices(inputs)
	if (locale === "ru") return ru_push_devices(inputs)
	if (locale === "tr") return tr_push_devices(inputs)
	if (locale === "it") return it_push_devices(inputs)
	if (locale === "pl") return pl_push_devices(inputs)
	if (locale === "uk") return uk_push_devices(inputs)
	if (locale === "hi") return hi_push_devices(inputs)
	if (locale === "ar") return ar_push_devices(inputs)
	if (locale === "ms") return ms_push_devices(inputs)
	if (locale === "bn") return bn_push_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_push_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_push_devices(inputs)
	if (locale === "ur") return ur_push_devices(inputs)
	if (locale === "fa") return fa_push_devices(inputs)
	if (locale === "sw") return sw_push_devices(inputs)
	if (locale === "nl") return nl_push_devices(inputs)
	return en_push_devices(inputs)
});